<template>
  <div class="relative" ref="notificationDropdown">
    <button 
      @click="toggleNotifications" 
      class="p-2 rounded-full hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 dark:focus:ring-offset-gray-800"
    >
      <svg class="w-6 h-6 text-gray-600 dark:text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9" />
      </svg>
      <span 
        v-if="kitchenNotificationCount > 0" 
        class="absolute -top-1 -right-1 flex items-center justify-center min-w-[1.25rem] h-5 px-1.5 text-xs font-semibold text-white bg-red-500 dark:bg-red-600 rounded-full animate-pulse"
      >
        {{ kitchenNotificationCount > 99 ? '99+' : kitchenNotificationCount }}
      </span>
    </button>
    
    <!-- Notification Dropdown -->
    <div v-if="showNotifications" class="absolute right-0 mt-2 w-80 bg-white dark:bg-gray-800 rounded-lg shadow-lg py-2 z-50 border border-gray-200 dark:border-gray-700">
      <div class="px-4 py-2 border-b border-gray-100 dark:border-gray-700">
        <h3 class="text-sm font-semibold text-gray-700 dark:text-gray-200">Benachrichtigungen</h3>
      </div>
      <div class="px-4 py-2 max-h-64 overflow-y-auto">
        <div v-if="kitchenNotificationCount > 0" class="mb-2">
          <div class="flex items-center justify-between p-2 bg-blue-50 dark:bg-blue-900/20 rounded-lg">
            <div class="flex items-center">
              <svg class="w-5 h-5 text-blue-600 dark:text-blue-400 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 6V4m0 2a2 2 0 100 4m0-4a2 2 0 110 4m-6 8a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4m6 6v10m6-2a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4" />
              </svg>
              <span class="text-sm font-medium text-gray-700 dark:text-gray-200">Küche</span>
            </div>
            <span class="text-sm font-semibold text-blue-600 dark:text-blue-400">{{ kitchenNotificationCount }} neue Bestellung{{ kitchenNotificationCount !== 1 ? 'en' : '' }}</span>
          </div>
          <button 
            @click="resetKitchenNotifications"
            class="mt-2 w-full text-xs text-blue-600 dark:text-blue-400 hover:underline text-center"
          >
            Als gelesen markieren
          </button>
        </div>
        <p v-else class="text-sm text-gray-500 dark:text-gray-400">Keine neuen Benachrichtigungen</p>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, onMounted, onUnmounted } from 'vue'
import { useOrderStore } from '@/stores/orders'

const orderStore = useOrderStore()
const notificationDropdown = ref(null)
const showNotifications = ref(false)

const kitchenNotificationCount = computed(() => orderStore.getUngeseheneBestellungenCount)

const toggleNotifications = () => {
  showNotifications.value = !showNotifications.value
}

const resetKitchenNotifications = () => {
  orderStore.resetUnseenOrdersCount()
}

// Schließen beim Klick außerhalb
const handleClickOutside = (event) => {
  if (notificationDropdown.value && !notificationDropdown.value.contains(event.target)) {
    showNotifications.value = false
  }
}

onMounted(() => {
  document.addEventListener('mousedown', handleClickOutside)
})

onUnmounted(() => {
  document.removeEventListener('mousedown', handleClickOutside)
})
</script> 